import React from 'react';
interface LogoProps {
  className?: string;
  alt?: string;
}
export function Logo({
  className = '',
  alt = 'Laugh Haus'
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/ukYPSHa6Qb1ddeovtfEED8/57e2966f-4b61-481d-803d-38ba6df88662.png" alt={alt} className={className} data-id="element-206" />;
}